import HTTPClient from './http-client';

const options = {
  cache: {
    maxAge: 24 * 60 * 60 * 1000,
    exclude: { query: false }
  }
}

const END_POINT = '/landuse_classes';

const loadClasses = async () => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}`,
    options
  );
}

export {
  loadClasses
}
